import { TableCell } from '@mui/material'
import React, { useState } from 'react'
import FormCell from './FormCell'

const FormRow = (props) => {
    const { column, columnIndex, rows, config, errorRef, helperFunction } = props
    const { renderColumns } = config

    const [_, forceRender] = useState({});
    const render = () => forceRender({})

    renderColumns[column?.uniqueName] = render

    const isLock = Object.hasOwn(column, "isReadOnly") ? column?.isReadOnly : false 
    const isFull =
        column?.type === "custom" ||
        column?.isFullWidth ||
        column?.type === "capaCustom" ||
        column?.t === "capaCustom";

    return (
        <>
            <TableCell colSpan={isFull ? 2 : 1} sx={isFull ? { p: 1 } : {}}>
                <FormCell
                    rows={rows}
                    column={column}
                    config={config}
                    columnIndex={columnIndex}
                    errorRef={errorRef}
                    helperFunction={
                        helperFunction
                    }
                    isLock={isLock}
                    // isDisable={ }
                />
            </TableCell>
        </>
    )
}

export default FormRow
